import PropTypes from 'prop-types';
import React from 'react';

import { Webcam } from '@powdr/components';
import { getHdRelaySrc } from '@powdr/utils';

import { StyledDorWebcams, WebcamContainer, WebcamLabel, WebcamPlayer } from './styles';

export const DorWebcams = ({
  relationships,
}) => {
  const { webcams } = relationships;

  return (
    <StyledDorWebcams $numCams={webcams?.length}>
      {webcams.map((cam) => {
        const hdRelaySrc = getHdRelaySrc(cam.relationships);
        const label = cam.webcamLabel || cam.relationships?.hdRelayCam?.name || '';

        if (hdRelaySrc || cam.webcamGuid) {
          return (
            <WebcamPlayer key={cam.id}>
              <Webcam
                id={cam.id}
                webcamGuid={cam.webcamGuid}
                relationships={cam.relationships}
              />
              {label && <WebcamLabel>{label}</WebcamLabel>}
            </WebcamPlayer>
          );
        }

        return (
          <WebcamContainer key={cam.id} href={cam.webcamLink}>
            <img src={cam.webcamImageSrc} alt={label} />
            <WebcamLabel>{label}</WebcamLabel>
          </WebcamContainer>
        );
      })}
    </StyledDorWebcams>
  );
};

DorWebcams.propTypes = {
  relationships: PropTypes.shape({
    webcams: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
};
